(function () {
  let refreshRunId = 0;

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function parseSection(sectionHtml, selector) {
    if (!sectionHtml) return null;
    return new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector(selector);
  }

  function getCartCount(cart) {
    if (!cart) return null;
    if (typeof cart.item_count === 'number') return cart.item_count;
    if (typeof cart.itemCount === 'number') return cart.itemCount;
    if (!Array.isArray(cart.items)) return null;

    return cart.items.reduce(function (total, item) {
      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function replaceSection(sectionHtml, selector) {
    const incoming = parseSection(sectionHtml, selector);
    if (!incoming) return;

    document.querySelectorAll(selector).forEach(function (node) {
      node.innerHTML = incoming.innerHTML;
    });
  }

  function renderSections(sections) {
    const trustpilotSnapshot =
      typeof window.__ivbSnapshotTrustpilotWidgets === 'function'
        ? window.__ivbSnapshotTrustpilotWidgets(document.getElementById('Cart-Drawer') || document)
        : null;

    replaceSection(sections['cart-drawer'], '#Cart-Drawer');
    replaceSection(sections['cart-bubble'], '[data-cart-count]');
    replaceSection(sections['main-cart'], '.thb-cart-form');

    if (typeof window.__ivbRestoreTrustpilotWidgets === 'function') {
      window.__ivbRestoreTrustpilotWidgets(document.getElementById('Cart-Drawer') || document, trustpilotSnapshot);
    }

    if (window.CPB && typeof window.CPB.refresh === 'function') {
      window.CPB.refresh('dialog-cart-ui-sync');
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:rerender'));
  }

  async function refreshCartUi(cart) {
    const runId = ++refreshRunId;
    const expectedCount = getCartCount(cart);
    const delays = [0, 250, 900];
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    let sections = null;

    try {
      for (const delay of delays) {
        await wait(delay);
        if (runId !== refreshRunId) return;

        const response = await fetch(
          `${root}?sections=main-cart,cart-drawer,cart-bubble&_dialog_cart_refresh=${Date.now()}`,
          { credentials: 'same-origin', cache: 'no-store' }
        );

        if (!response.ok) throw new Error(`Cart sections request failed: ${response.status}`);

        sections = await response.json();
        const countNode = parseSection(sections['cart-bubble'], '[data-cart-count]');
        const incomingCount = countNode ? Number(countNode.textContent.trim()) : null;

        renderSections(sections);

        if (expectedCount === null || incomingCount === expectedCount) {
          return;
        }
      }

    } catch (error) {
      console.error('[Dialog Cart] Cart UI refresh failed', error);
    }
  }

  document.addEventListener('dialog:cart:updated', function (event) {
    refreshCartUi(event.detail && event.detail.cart);
  });
})();
